import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PowerNavigate } from 'components/PowerNavigate';
import withCustomInfo from 'utils/withCustomInfo';
import Address from './Address';
import Agreements from './Agreements';
import BaseInfo from './BaseInfo';
import Invest from './Invest';
import Job from './Job';
import QualificationQuestionnaire from './QualificationQuestionnaire';
import Revenue from './Revenue';
import Summary from './Summary';
import W8 from './W8';

/** 美国大客户开户：https://tigertech.feishu.cn/wiki/ThYZwAuDfigZIxkfzticcC6HnHe */
const Confirm: FC = () => {
    return (
        <Routes>
            <Route path="summary" element={<Summary />} />
            <Route path="baseinfo" element={<BaseInfo />} />
            <Route path="address" element={<Address />} />
            <Route path="job" element={<Job />} />
            <Route path="qualification-questionnaire" element={<QualificationQuestionnaire />} />
            <Route path="invest" element={<Invest />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="w8" element={<W8 />} />
            <Route path="agreements" element={<Agreements />} />
            <Route path="*" element={<PowerNavigate to="summary" replace />} />
        </Routes>
    );
};

export default withCustomInfo(Confirm);
